class Registration extends require("lib/static-shim").default(
  require("lib/utils/model").default
) {
  defaults() {
    return {
      role: null, // this is overriden by whatever role the invitation_code is set to
      path: null,
      payment_token: null, // stripe payment token if payment is required and were selling via stripe
      invitation_hash: null, // if the user was invited to a class via email
      invitation_code: null, // if the user was invited to a class via link
      coupon_code: null,
      send_confirmation_email: true, // optional, default to true
      is_pre_payed: false,
      offering: null,
      resource: null,
      user: null
    }
  }

  url() {
    const { resource, offering, id } = this.attributes
    if (resource && offering) {
      return this.urlRoot(
        `api/private/library/resource/${resource.id}/offering/${offering.id}/registration/`
      )
    } else if (id) {
      return this.urlRoot(`/api/private/registration/${id}/`)
    }
  }
}

export default Registration
